import React from "react"
import Link from "./link"
import Img from "gatsby-image"
import { Box, Text, Flex } from "theme-ui"
import { LangContext } from "../context/langContext"
import ArrowLink from "./arrowLink"
import { getHomePath, getPagePath } from "../utils/pathUtils"


const SubCategoryThumb = ({ subcategory, t }) => {
  // console.log(subcategory)
  return (
    <LangContext.Consumer>
      {t => (
        <Link
          to={getPagePath(subcategory)}
          key={subcategory.id}
          sx={{ textDecoration: "none" }}
        >
          <Box
            sx={{
              position: "relative",
              backgroundImage:
                "linear-gradient(90deg, #E54415, #E54415), linear-gradient(90deg, #E54415, #E54415), linear-gradient(90deg, #E54415, #E54415), linear-gradient(90deg, #E54415, #E54415)",
              backgroundSize:
                "12px 80%, 100% 12px, 12px 100%, 50% 12px",
              backgroundPosition: "0 0, 0 0, 100% 0, 100% 100%",
              backgroundRepeat: "no-repeat",
              minHeight: ["20rem", "20rem"],
            }}
            p={4}
          >
            <Flex
              sx={{ flexDirection: "column", alignItems: "flex-end" }}
            >
              <Text
                as="h2"
                variant="lead"
                sx={{ textAlign: "right" }}
              >
                {subcategory.shortName || subcategory.name}
              </Text>
              <ArrowLink anchor={t.discoverMore} />
            </Flex>
            <Box
              sx={{
                position: "absolute",
                width: "90%",
                bottom: "-20px",
                left: 0,
              }}
            >
              {subcategory.image && (
                <Img fluid={subcategory.image.fluid} />
              )}
            </Box>
          </Box>
        </Link>
      )
      }

    </LangContext.Consumer>
  )
}

export default SubCategoryThumb
